module.exports = __webpack_public_path__ + "img/no-answer.5fa76f9d.png";